import { render, staticRenderFns } from "./Orgstruct.vue?vue&type=template&id=9b0daf4c"
import script from "./Orgstruct.vue?vue&type=script&lang=js"
export * from "./Orgstruct.vue?vue&type=script&lang=js"
import style0 from "./Orgstruct.vue?vue&type=style&index=0&id=9b0daf4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports